//import firebase from 'firebase/app'
import { _firebase as $_firebase } from "@/model/firebase";

const tags = {
  async list(){
    let tags = []
    await $_firebase.firestore().collection('tag').get().then( snapshot => { snapshot.forEach( doc => { let item = doc.data(); item.id = doc.id;  tags.push(item) });  });
    return tags;
  },
  async get(tagID=false){
    if(tagID){
      let mon = $_firebase.firestore().collection('tag').doc(tagID)
      const snapshot = await mon.get();
      let tag = snapshot.data(); tag.id = snapshot.id
      return tag;
    }else{
      let tags = []
      let snapshot = await $_firebase.firestore().collection('tag').get();
      tags = snapshot.docs.map(element => element.data());
      for (const [key,t] of Object.entries(tags)) { tags[key] = t.name; } 
      return tags;
    }
  },
  async getColors(tagID=false){
    let tagColor = []; let selColor = []
    let snapshot  = await $_firebase.firestore().collection('view').doc('tags').get()
    let item = snapshot.data();
    for (const [key,c] of Object.entries(item.tag_color)) { 
      if(tagID && tagID==key)selColor.push({ tag: key, color: c }); 
      tagColor[key]= { tag: key, color: c }; 
    } 
    if(tagID)return selColor               
    return tagColor;
  },
  async init() { 
    let tags = []
    let list = await this.list()
    for (const tag of Object.values(list)) {
      let tagName = await this.get(tag.id);
      tags[tag.id] = tagName.name
    }
    return tags;
  }   
};

const install = app => {
  app.config.globalProperties.$tags = tags;
};

export { install as default, tags as tag };
